import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { TestGroup } from "../domain/test-group";
import { CoreData } from "../tools/core-data/core-data";
import { mapper } from "../tools/mapping/mapper";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { TestGroupDTO } from "./dto/test-group.dto";
import { AppConfig } from "../app.config";

@Injectable({
    providedIn: 'root',
})
export class TestGroupService extends BaseService {

    private serviceUrl = `${this.config.getConfig('serviceBaseUrl')}api/testgroup`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected override snackBar: MatSnackBar,
        protected override oauthService: OAuthService,
        private loadingTask: LoadingTask,
        protected override router: Router,
        private config: AppConfig) {
        super(router, coreData, oauthService, snackBar);
    }

    getTestGroupListByProduct(productGroupCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/byProductGroup/${productGroupCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('cregetTestGroupListByProductate')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: TestGroupDTO[]) => {
                return response.map((item: TestGroupDTO) => {
                    return mapper.map(item, TestGroupDTO, TestGroup);
                });
            }));
    }

    getTestGroupByCode(groupCode: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${groupCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getTestGroupByCode')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: TestGroupDTO) => {
                return mapper.map(response, TestGroupDTO, TestGroup);
            }));
    }

    updatePosition(productGroupCode: string, testGroupList: TestGroup[]) {
        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}/byProductGroup/${productGroupCode}`, testGroupList, this.generateHeader()).pipe(
            catchError(this.handleError<any>('updatePosition')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }

    create(tg: TestGroup, productGroupCode: string) {

        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/${productGroupCode}`, tg, this.generateHeader()).pipe(
            catchError(this.handleError<any>('create')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    update(tg: TestGroup) {

        this.loadingTask.activateLoading();
        return this.http.put(`${this.serviceUrl}`, tg, this.generateHeader()).pipe(
            catchError(this.handleError<any>('update')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    delete(testGroupCode: string) {

        this.loadingTask.activateLoading();
        return this.http.delete(`${this.serviceUrl}/${testGroupCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('delete')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: boolean) => {
                return response;
            }));
    }
}